<template>
<div class="canvas-wrap">
	<div class="header">
		<div class="title">剧本评估</div>
		<div class="score">
			<div class="level">
				<span>·评级：</span><span class="red-bold">{{scoreDetail&&scoreDetail.level}}</span>
			</div>
			<div class="score-num">
				<span>·总分(0-120)：</span><span class="red-bold">{{scoreDetail&&scoreDetail.score}}分</span>
			</div>
		</div>
	</div>
	<div class="canvas-box">
		<canvas id="canvas">
			您的浏览器不支持CANVAS,请更换浏览器重试。
		</canvas>
	</div>
	<router-link :to="{name:'filmscoredetail',query:{id:this.$route.query.id,type:this.$route.query.type}}"><div class="to-detail" v-if="!detail"><span>查看详情</span></div></router-link>
</div>
</template>

<script>
import {Axios} from '@/assets/api/axios'
export default {
	name:'fimeScore',
	props:['detail'],
	data(){
		return{
			CANVAS_WIDTH:'',
			CANVAS_HEIGHT:'',
			scoreNumItem:'',                    //评分分数
			totalScore:'',                      //总分
			totalLevel:'',                      //总评级
			scoreDetail:'',                     //评分总信息
			dpr:'',
			mapR:''
		}
	},
	created(){
		//获取评估详情数据
		Axios.get('article/assess',{params:{type:Number(this.$route.query.type),id:Number(this.$route.query.id)}}).then(
			response=>{
				if(response.data.code==200&&response.data.status=="success"){
					this.scoreDetail=response.data.data
					this.scoreNumItem=JSON.parse(response.data.data.item)
					this.totalScore=response.data.data.score
					this.totalLevel=response.data.data.level
					this.draw()
				}
			},
			error=>{
				console.log(error)
			}
		)
	},
	mounted(){
		this.dpr = window.devicePixelRatio; 
		this.CANVAS_WIDTH=document.querySelector('.canvas-box').getBoundingClientRect().width
		this.CANVAS_HEIGHT=document.querySelector('.canvas-box').getBoundingClientRect().height
		canvas.width=this.CANVAS_WIDTH
		canvas.height=this.CANVAS_HEIGHT
		
	},
	methods:{
		draw(){
			let canvas=document.querySelector('#canvas');
			let ctx=canvas.getContext('2d');
			ctx.scale(this.dpr,this.dpr);
			ctx.lineWidth=1;
			ctx.globalCompositeOperation="source-over";

			let rangeNum=[0,5,10,15,20];
			let ScoreItem=[
				'人物塑造',
				'',
				'',
				'',
				'',
				'戏剧冲突',
				'戏剧冲突',
				'人物塑造'
			];
			let ScoreDetailItem=[
				'人物原型(0-10)：',
				'节拍表(0-20)：',
				'类型',
				'格式(0-20)：',
				'片名及主题(0-10)：',
				'英雄之旅(0-10)：',
				'三十六种戏剧',
				'心理分析(0-20)：'
			];
			let scoreNumArr=[];
			scoreNumArr[0]=this.scoreNumItem['person_score']
			scoreNumArr[1]=this.scoreNumItem['bate_score']
			scoreNumArr[2]=this.scoreNumItem['type_score']
			scoreNumArr[3]=this.scoreNumItem['format_score']
			scoreNumArr[4]=this.scoreNumItem['complete_score']
			scoreNumArr[5]=this.scoreNumItem['hero_score']
			scoreNumArr[6]=this.scoreNumItem['_36_score']
			scoreNumArr[7]=this.scoreNumItem['iaap_score']
			
			canvas.style.width = canvas.width + 'px';
        	canvas.style.height = canvas.height + 'px';
     
        	canvas.width = this.dpr * this.CANVAS_WIDTH;
			canvas.height = this.dpr * this.CANVAS_HEIGHT;
			
			//多边形半径
			this.mapR=canvas.width/2-130;
			
			//依次绘制评分模型八边形图
			for(let i=0;i<4;i++){
				ctx.beginPath();
				ctx.strokeStyle="#ccc";
				if((i+1)%2===0) {
					ctx.fillStyle="#F7F6F9";
				}else{
					ctx.fillStyle="#fff";
					
				}
				this.drawFilmMap(ctx,this.mapR-i*this.mapR/4);
				ctx.closePath();
				ctx.fill();
				ctx.stroke();
			}

			//绘制中心点散发虚线
			ctx.beginPath();
			ctx.strokeStyle="#ccc";
			this.drawDashLine(ctx,this.mapR);
			ctx.stroke();
			ctx.closePath();

			//添加评分盘内部数字分值文字
			ctx.beginPath();
			ctx.fillStyle="#D24E06";
			ctx.font="bold 16px Arial";
			ctx.textAlign="left";
			for(let i=0;i<5;i++){
				ctx.fillText(rangeNum[i],canvas.width/2+16,(canvas.height/2-this.mapR/4*i)+8)
			}
			ctx.fill();
			ctx.closePath();

			//添加外圈评分项大标题文字
			ctx.beginPath();
			ctx.fillStyle="#222";
			ctx.font="bold 20px 微软雅黑";
			ctx.textAlign="center";
			ctx.fillText(ScoreItem[0],(Math.sin((0*45)/180*Math.PI))*this.mapR+canvas.width/2,(Math.cos((0*45)/180*Math.PI))*this.mapR+canvas.height/2+30);
			ctx.fillText(ScoreItem[1],(Math.sin((1*45)/180*Math.PI))*this.mapR+canvas.width/2,(Math.cos((1*45)/180*Math.PI))*this.mapR);
			ctx.fillText(ScoreItem[2],(Math.sin((2*45)/180*Math.PI))*this.mapR+canvas.width/2,(Math.cos((2*45)/180*Math.PI))*this.mapR);
			ctx.fillText(ScoreItem[3],(Math.sin((3*45)/180*Math.PI))*this.mapR+canvas.width/2,(Math.cos((3*45)/180*Math.PI))*this.mapR);
			ctx.fillText(ScoreItem[4],(Math.sin((4*45)/180*Math.PI))*this.mapR+canvas.width/2,(Math.cos((4*45)/180*Math.PI))*this.mapR);
			ctx.fillText(ScoreItem[5],(Math.sin((5*45)/180*Math.PI))*this.mapR+canvas.width/2-124,(Math.cos((5*45)/180*Math.PI))*this.mapR+canvas.height/2-20);
			ctx.fillText(ScoreItem[6],(Math.sin((6*45)/180*Math.PI))*this.mapR+canvas.width/2-80,(Math.cos((6*45)/180*Math.PI))*this.mapR+canvas.height/2);
			ctx.fillText(ScoreItem[7],(Math.sin((7*45)/180*Math.PI))*this.mapR+canvas.width/2-108,(Math.cos((7*45)/180*Math.PI))*this.mapR+canvas.height/2);
			
			//外圈评分副标题文字
			ctx.fillStyle="#333";
			ctx.font="normal 20px 微软雅黑";
			ctx.textAlign="left";
			ctx.fillText(ScoreDetailItem[0],(Math.sin((0*45)/180*Math.PI))*this.mapR+canvas.width/2-72,(Math.cos((0*45)/180*Math.PI))*this.mapR+canvas.height/2+55);
			ctx.fillText(ScoreDetailItem[1],(Math.sin((1*45)/180*Math.PI))*this.mapR+canvas.width/2+10,(Math.cos((1*45)/180*Math.PI))*this.mapR+canvas.height/2+10);
			ctx.fillText(ScoreDetailItem[2],(Math.sin((2*45)/180*Math.PI))*this.mapR+canvas.width/2+6,(Math.cos((2*45)/180*Math.PI))*this.mapR+canvas.height/2);
			ctx.fillText('(0-20):',(Math.sin((2*45)/180*Math.PI))*this.mapR+canvas.width/2+6,(Math.cos((2*45)/180*Math.PI))*this.mapR+canvas.height/2+25);
			ctx.fillText(ScoreDetailItem[3],(Math.sin((3*45)/180*Math.PI))*this.mapR+canvas.width/2+10,(Math.cos((3*45)/180*Math.PI))*this.mapR+canvas.height/2);
			ctx.fillText(ScoreDetailItem[4],(Math.sin((4*45)/180*Math.PI))*this.mapR+canvas.width/2-72,(Math.cos((4*45)/180*Math.PI))*this.mapR+canvas.height/2-30);
			ctx.fillText(ScoreDetailItem[5],(Math.sin((5*45)/180*Math.PI))*this.mapR+canvas.width/2-164,(Math.cos((5*45)/180*Math.PI))*this.mapR+canvas.height/2+5);
			ctx.fillText(ScoreDetailItem[6],(Math.sin((6*45)/180*Math.PI))*this.mapR+canvas.width/2-120,(Math.cos((6*45)/180*Math.PI))*this.mapR+canvas.height/2+25);
			ctx.fillText("情境(0-10):",(Math.sin((6*45)/180*Math.PI))*this.mapR+canvas.width/2-120,(Math.cos((6*45)/180*Math.PI))*this.mapR+canvas.height/2+45);
			ctx.fillText(ScoreDetailItem[7],(Math.sin((7*45)/180*Math.PI))*this.mapR+canvas.width/2-148,(Math.cos((7*45)/180*Math.PI))*this.mapR+canvas.height/2+25);
			
			//外圈评分分数数字
			ctx.fillStyle="#D24E06";
			ctx.font="bold 22px Arial";
			ctx.textAlign="left";
			ctx.fillText(this.scoreNumItem['person_score'],(Math.sin((0*45)/180*Math.PI))*this.mapR+canvas.width/2+74,(Math.cos((0*45)/180*Math.PI))*this.mapR+canvas.height/2+56);
			ctx.fillText(this.scoreNumItem['bate_score'],(Math.sin((1*45)/180*Math.PI))*this.mapR+canvas.width/2+138,(Math.cos((1*45)/180*Math.PI))*this.mapR+canvas.height/2+11);
			ctx.fillText(this.scoreNumItem['type_score'],(Math.sin((2*45)/180*Math.PI))*this.mapR+canvas.width/2+70,(Math.cos((2*45)/180*Math.PI))*this.mapR+canvas.height/2+25);
			ctx.fillText(this.scoreNumItem['format_score'],(Math.sin((3*45)/180*Math.PI))*this.mapR+canvas.width/2+118,(Math.cos((3*45)/180*Math.PI))*this.mapR+canvas.height/2+1);
			ctx.fillText(this.scoreNumItem['complete_score'],(Math.sin((4*45)/180*Math.PI))*this.mapR+canvas.width/2+96,(Math.cos((4*45)/180*Math.PI))*this.mapR+canvas.height/2-29);
			ctx.textAlign="center";
			ctx.fillText(this.scoreNumItem['hero_score'],(Math.sin((5*45)/180*Math.PI))*this.mapR+canvas.width/2-12,(Math.cos((5*45)/180*Math.PI))*this.mapR+canvas.height/2+5+2);
			ctx.fillText(this.scoreNumItem['_36_score'],(Math.sin((6*45)/180*Math.PI))*this.mapR+canvas.width/2-10,(Math.cos((6*45)/180*Math.PI))*this.mapR+canvas.height/2+45+2);
			ctx.fillText(this.scoreNumItem['iaap_score'],(Math.sin((7*45)/180*Math.PI))*this.mapR+canvas.width/2+9,(Math.cos((7*45)/180*Math.PI))*this.mapR+canvas.height/2+25+1);
			ctx.fill();
			ctx.closePath();

			//绘制中心评分图形
			ctx.beginPath();
			ctx.fillStyle="rgba(210,78,6,0.2)";
			ctx.strokeStyle="#D24E06";
			this.drawScoreArea(ctx,this.mapR,scoreNumArr)
			ctx.closePath();
			ctx.fill();
			ctx.stroke();

			//绘制交叉点小圆球
			this.drawSmallBall(ctx,this.mapR,scoreNumArr);
		},
		//定义绘制八边形函数
		drawFilmMap(ctx,r){
			for(let i=0;i<8;i++){
				ctx.lineTo(
					(Math.sin((i*45)/180*Math.PI))*r+canvas.width/2,(Math.cos((i*45)/180*Math.PI))*r+canvas.height/2
				)
			}
		},
		//定义绘制中心点散发虚线函数
		drawDashLine(ctx,r){
			ctx.setLineDash([3]);
			for(let i=0;i<8;i++){
				ctx.moveTo(canvas.width/2,canvas.height/2);
				ctx.lineTo((Math.sin((0+i*45)/180*Math.PI))*r+canvas.width/2,(Math.cos((0+i*45)/180*Math.PI))*r+canvas.height/2);
			}
		},
		//定制评分中心区域可视化分值多边形
		drawScoreArea(ctx,r,score){
			ctx.setLineDash([]);
			for(let i=0;i<8;i++){
				ctx.lineTo(
					(Math.sin((i*45)/180*Math.PI))*(r*(score[i]/20))+canvas.width/2,(Math.cos((i*45)/180*Math.PI))*(r*(score[i]/20))+canvas.height/2
				);
			};
		},
		//交叉点圆点
		drawSmallBall(ctx,r,score){
			for(let i=0;i<8;i++){
				ctx.beginPath();
				ctx.lineWidth="1";
				ctx.strokeStyle="#D24E06";
				ctx.fillStyle="rgba(210,78,6,0.3)";
				ctx.arc(
					(Math.sin((0+i*45)/180*Math.PI))*(r*(score[i]/20))+canvas.width/2,(Math.cos((0+i*45)/180*Math.PI))*(r*(score[i]/20))+canvas.height/2,3,0*Math.PI,2.0*Math.PI
				);
				ctx.fill();
				ctx.stroke();
			};
		},
	}
}
</script>

<style lang="scss" scoped>
.red-bold{
	font-size:24px;
	color:#B31E23;
}
.canvas-wrap{
	width:100%;
	height:800px;
	.header{
		height:40px;
		background:#fff;
		font-size:30px;
		font-weight:bold;
		padding:10px 0px 50px 0px;
		color:#222;
		.title{
			float:left;
		}
		.score{
			float:right;
			div{
				display:inline-block;
				font-size:20px;
			}
			span{
				vertical-align:middle;
			}
			.level{
				margin-right:20px;
			}
		}
	}
	.canvas-box{
		height:610px;
	}
	.to-detail{
		height:60px;
		background:#fff;
		text-align:center;
		padding-top:38px;
		span{
			display:inline-block;
			font-size:20px;
			padding:15px 80px;
			color:#fff;
			background:#282828;
		}
		span:active{
			background:#555;
		}
	}
}
</style>